<template>
    <div
        class="nline"
        :class="[`nline--${direction}`, { 'nline--dashed': dashed }]"
        :style="lineStyle">
        <slot></slot>
    </div>
</template>

<!-- 基础水平分割线 -->
<!-- <nline /> -->
<!-- 垂直分割线 -->
<!-- <nline direction="vertical" /> -->
<!-- 自定义颜色和粗细 -->
<!-- <nline color="#ff0000" thickness="2px" /> -->
<!-- 虚线分割线 -->
<!-- <nline dashed /> -->
<!-- 自定义间距 -->
<!-- <nline margin="24px" /> -->
<!-- 自定义长度 -->
<!-- <nline length="200px" /> -->

<script setup lang="ts">
import { computed } from 'vue';
import { pxToRem } from '@/utils/rem/rem';

interface Props {
    direction?: 'horizontal' | 'vertical';
    color?: string;
    thickness?: string | number;
    margin?: string | number;
    dashed?: boolean;
    length?: string | number;
}

const props = withDefaults(defineProps<Props>(), {
    direction: 'horizontal',
    color: 'var(--line-color-2)',
    thickness: 1,
    margin: 16,
    dashed: false,
    length: '100%'
});

const lineStyle = computed(() => {
    const thickness = `${pxToRem(props.thickness)}`;
    const margin = `${pxToRem(props.margin)}`;
    const length = typeof props.length === 'number' ? `${pxToRem(props.length)}` : props.length;

    if (props.direction === 'horizontal') {
        return {
            width: length,
            height: thickness,
            backgroundColor: `${props.color}`,
            margin: `${margin} 0`
        };
    } else {
        return {
            width: thickness,
            height: length,
            backgroundColor: `${props.color}`,
            margin: `0 ${margin}`
        };
    }
});
</script>

<script lang="ts">
export default {
    name: 'NLine'
};
</script>

<style scoped lang="scss">
.nline {
    flex-shrink: 0;

    &--horizontal {
        align-self: stretch;
    }

    &--vertical {
        align-self: stretch;
    }
}
</style>
